import 'bootstrap/dist/js/bootstrap'
import * as braintreeDropin from 'braintree-web-drop-in'
import * as $ from 'jquery'
import "jquery-ujs"
import { sendGoogleAnalytics } from '../utils/helpers'

$(document).on('click', '.js-flash-close', function(e) {
  e.preventDefault()
  $(this).parent('.flash').hide()
})

// Toggles visibility of continue button on sign agreement page
$(document).on('change', '.js-sign-agreement', function(e) {
  e.preventDefault()
  const checkbox = this as HTMLInputElement
  if (checkbox.checked) {
    $('.js-continue-to-payment').removeClass('hidden')
  } else {
    $('.js-continue-to-payment').addClass('hidden')
  }
})

// Fancy checkboxes
$(document).on('click', '.input-checkbox', function(e) {
  const $checkbox = $(this)
  $checkbox.toggleClass('checked')

  const input = $checkbox.find('input')
  if (input.prop('checked') === false) {
    input.prop('checked', true)
  } else {
    input.prop('checked', false)
  }
  input.trigger('change')
  return false
})

// Fancy radio buttons
$(document).on('click', '.input-radio', function(e) {
  if ($(e.target).is('input')) { return }
  const $radio = $(this)
  const name  = $radio.find('input[type=radio]').attr('name')
  const sanitizedName = (name || '').replace(/\[[^\]]*\]/g, '')

  $radio.closest('form').find(`[type=radio][name*=${sanitizedName}]`).each(function() {
    $(this).parent().removeClass('checked')
  })
  $radio.addClass('checked').find('input').click().prop('checked', true)
  return false
})

// Needed for Turbolinks if its added
//
// Reset the state of the navbar if cached between pages
// document.addEventListener('turbolinks:before-visit', () => {
//   const $navbar = $('.navbar-collapse')

//   if ( $navbar.hasClass('in') ) {
//     ($navbar as any).collapse('hide')
//   }
// })

$(() => {
  sendGoogleAnalytics()
  //
  // Braintree
  //
  const container = document.getElementById('braintree-dropin-container')
  if (!container) { return }

  $('#license_purchase_nonce').val('')

  braintreeDropin.create({
    authorization: container.dataset.clientToken,
    container: '#braintree-dropin-container'
  }, (createErr: any, instance: any) => {
    $(document).on('click', '.js-braintree-payment-page-submit', () => {
      const $submit = $('.js-braintree-payment-page-submit')
      $submit.prop('disabled', true)
      instance.requestPaymentMethod( (requestPaymentMethodErr: any, payload: any) => {
        if (!requestPaymentMethodErr) {
          $('#license_purchase_nonce').val(payload.nonce)
          $('#new_license_purchase').submit()
        } else {
          $submit.prop('disabled', false)
        }
      })
    })
  })
})

// devise/registrations
$(document).ready(function() {
  
  var showCityState = function() {
    var c = $('#user_company_country').val();
    if (c != '' && c != 'United States of America') {
      $('.city, .state').show();
      // $('#zip-post').text('Post');
    } else {
      // $('#zip-post').text('Zip');
    }
  };
  showCityState();
  $('#user_company_country').on('change', function() {
    showCityState();
  });
});
